import { atom } from 'recoil';

export const upLevelAtom = atom({
  key: 'upLevelAtom',
  default: {
    isPlayMedalAnimation: false,
    lastLevelUpDate: null,
  },
});
